/*
 * react-datepicker's default popper sits at z-index: 1 and renders inline,
 * which leaves the calendar trapped beneath sibling content inside the
 * irrigation-history list/map stacking contexts. We render the calendar in a
 * top-level portal (portalId="datepicker-portal") and lift the portal above
 * app content here. Loaded after react-datepicker.css so these win on order.
 */
#datepicker-portal {
  position: relative;
  z-index: 9999;
}

.react-datepicker-popper {
  z-index: 9999;
}
